module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","learningTenants":"Mandanten"},"en":{"add":"Add","learningTenants":"LearningTenants"}}')
  delete Component.options._Ctor
}
